var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{ref:"me",class:_vm.iconClass,attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.is_loading},on:{"click":_vm.on_query}},[_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }